// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PzBz","label":"styles_label__2XQ71"};